declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
  }
}

export const META_PIXEL_ID = '962279486187488'

// Official Meta Pixel base code (verbatim), injected as an inline script so
// it behaves exactly like pasting it into the page <head>.
const PIXEL_SNIPPET = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');
`

export function initMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) return
  const script = document.createElement('script')
  script.id = 'meta-pixel-base'
  script.text = PIXEL_SNIPPET
  document.head.appendChild(script)
}

export function trackAddToCart() {
  const params = {
    content_name: 'El Escudo de Mamá',
    content_type: 'product',
    value: 17,
    currency: 'USD',
  }
  if (window.fbq) {
    window.fbq('track', 'AddToCart', params)
    return
  }
  // Fallback if the pixel script was blocked from loading.
  const img = new Image()
  img.src =
    `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=AddToCart` +
    `&cd[value]=17&cd[currency]=USD&noscript=1`
}
